import React, { memo, ReactNode } from "react";
import { RCCGrid, RCCIcon, RCCProgress } from "react-common-components";
import UserColumn from "src/components/DefaultColumnsList/User";
import List from "src/components/List";
import { useTranslation } from "src/context/Translations/context";
import formatDate from "src/utils/formatDate";
import { IProject } from "src/pages/Projects/Project/interface";
import WrapText from "src/components/WrapText";
import HoursProjectsContainer from "../HoursProjects/container";

export interface IProjectItem {
	data: IProject[];
    filter?: (a: any, index?: number | undefined) => boolean;
    showHeader: boolean;
    imageOnly: boolean;
    options: (row: any) => ReactNode;
}

const ProjectItem: React.FC<IProjectItem> = ({
	data,
	filter,
	showHeader,
	imageOnly,
	options
}) => {
	const { translate, currentLanguage } = useTranslation();

	const colProject = (row: any) => (
		<WrapText lineClamp={2} title={row.fullTitle} bold>
			{row.fullTitle}
		</WrapText>
	);

	const colUser = (row: any) => (
		<UserColumn 
			name={row.pra002Efa005Nome}
			image={row.pra002Efa005Imagem}
			imageOnly={imageOnly}
		/>
	);

	const colPeriod = (row: any) => (
		<RCCGrid 
			item
			container
		>
			<div style={{marginRight: "10px"}}>
				{
					row.pra002ControlaHoras === "S" &&
					<HoursProjectsContainer projectId={row.pra002Id}/>
				}
			</div>
			<div>
				<RCCGrid container item>
					<RCCIcon 
						className="head-title"
						name="calendar"
						size={16}
						style={{marginRight: "4px"}}
					/>
					{formatDate(row.pra002Dtiniest, currentLanguage)} - {formatDate(row.pra002Dtfimest, currentLanguage)}
				</RCCGrid>
			</div>
				
		</RCCGrid>
	);

	const colPercentConclusion = (row: any) => (
		<RCCGrid
			container
			item
			alignItems="center"
			style={{ margin: "4px" }}
		>
			<RCCProgress 
				color={`var(--${row.completionPercentageColor})`}
				layout="line"
				value={row.completionPercentage || 0}
			/>
		</RCCGrid>
	);

	const colPercentPrevision = (row: any) => (
		<RCCGrid
			container
			item
			alignItems="center"
			style={{ margin: "4px" }}
		>
			<RCCProgress 
				layout="line"
				value={row.expectedPercentage || 0}
			/>
		</RCCGrid>
	);

	const colBadge = (row: any) => (
		<RCCGrid container justifyContent="center">{row.completed || 0}/{row.count || 0}</RCCGrid>
	);

	return(
		<List 
			showHeader={showHeader}
			filter={filter}
			data={data}
			columns={[
				{
					idColumn: "name",
					nameColumn: `${translate("Projeto")}`,
					xs: 12,
					sm: 4,
					justify: "left",
					cellRenderer: colProject
				},
				{
					idColumn: "user",
					nameColumn: translate("Responsável"),
					xs: 12,
					sm: 2,
					justify: "left",
					cellRenderer: colUser
				},
				{
					idColumn: "period",
					nameColumn: translate("Período"),
					xs: 12,
					sm: 2,
					justify: "left",
					cellRenderer: colPeriod
				},
				{
					idColumn: "percConclusao",
					nameColumn: translate("% Conclusão"),
					justify: "left",
					xs: 12,
					sm: 1,
					cellRenderer: colPercentConclusion
				},
				{
					idColumn: "percPrevisto",
					nameColumn: translate("% Previsto"),
					justify: "left",
					xs: 12,
					sm: 1,
					hidden: ["sm"],
					cellRenderer: colPercentPrevision
				},
				{
					idColumn: "details",
					nameColumn: translate("Ações completadas"),
					justify: "left",
					xs: 12,
					sm: 1,
					hidden: ["sm"],
					cellRenderer: colBadge
				},
				{
					idColumn: "options",
					nameColumn: " ",
					xs: 12,
					sm: 1,
					cellRenderer: options
				}]}
			layout="table"
		/>
	);};

export default memo(ProjectItem);
